export default __webpack_public_path__ + "static/media/gitBranch.cd9e199b.svg";